import angular from 'angular';
import creditworthinessMoreInfoComponent from './creditworthinessMoreInfo.component';

let creditworthinessMoreInfoModule = angular.module('creditworthinessMoreInfo', [
])

.component('creditworthinessMoreInfo', creditworthinessMoreInfoComponent)

.name;

export default creditworthinessMoreInfoModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessMoreInfo/creditworthinessMoreInfo.js